/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiParameter } from '../../asyncapi/models/AaiParameter';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';

/**
 * A command used to rename a channel item, along with all references to it.
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class RenameChannelItemCommand extends AbstractCommand {
    public _oldChannelName : string;

    public _newChannelName : string;

    public _channelExisted : boolean;

    public _nullParams : boolean;

    public _paramBin : any;

    public _nodeFactory : Aai20NodeFactory;

    public constructor(oldChannelName? : any, newChannelName? : any) {
        if(((typeof oldChannelName === 'string') || oldChannelName === null) && ((typeof newChannelName === 'string') || newChannelName === null)) {
            let __args = arguments;
            super();
            if(this._oldChannelName===undefined) this._oldChannelName = null;
            if(this._newChannelName===undefined) this._newChannelName = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._nullParams===undefined) this._nullParams = false;
            this._paramBin = <any>({});
            this._nodeFactory = new Aai20NodeFactory();
            if(this._oldChannelName===undefined) this._oldChannelName = null;
            if(this._newChannelName===undefined) this._newChannelName = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._nullParams===undefined) this._nullParams = false;
            (() => {
                this._oldChannelName = oldChannelName;
                this._newChannelName = newChannelName;
            })();
        } else if(oldChannelName === undefined && newChannelName === undefined) {
            let __args = arguments;
            super();
            if(this._oldChannelName===undefined) this._oldChannelName = null;
            if(this._newChannelName===undefined) this._newChannelName = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._nullParams===undefined) this._nullParams = false;
            this._paramBin = <any>({});
            this._nodeFactory = new Aai20NodeFactory();
            if(this._oldChannelName===undefined) this._oldChannelName = null;
            if(this._newChannelName===undefined) this._newChannelName = null;
            if(this._channelExisted===undefined) this._channelExisted = false;
            if(this._nullParams===undefined) this._nullParams = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameChannelItemCommand] Executing.");
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isNullOrUndefined(aai20Document.channels)) {
            return;
        }
        if(/* containsKey */aai20Document.channels.hasOwnProperty(this._newChannelName)) {
            this._channelExisted = true;
            return;
        } else {
            this._channelExisted = false;
        }
        let aaiChannel : AaiChannelItem = /* remove */(map => { let deleted = aai20Document.channels[this._oldChannelName];delete aai20Document.channels[this._oldChannelName];return deleted;})(aai20Document.channels);
        if(this.isNullOrUndefined(aaiChannel)) {
            return;
        }
        aaiChannel.rename(this._newChannelName);
        /* put */(aai20Document.channels[this._newChannelName] = aaiChannel);
        this._nullParams = ModelUtils.isNullOrUndefined(aaiChannel.parameters);
        this._doParametersRename(aaiChannel, this._oldChannelName, this._newChannelName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameChannelItemCommand] Reverting.");
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isNullOrUndefined(aai20Document.channels)) {
            return;
        }
        if(this._channelExisted) {
            return;
        }
        let aaiChannel : AaiChannelItem = /* remove */(map => { let deleted = aai20Document.channels[this._newChannelName];delete aai20Document.channels[this._newChannelName];return deleted;})(aai20Document.channels);
        if(this.isNullOrUndefined(aaiChannel)) {
            return;
        }
        aaiChannel.rename(this._oldChannelName);
        /* put */(aai20Document.channels[this._oldChannelName] = aaiChannel);
        if(this._nullParams) {
            NodeCompat.setProperty(aaiChannel, Constants.PROP_PARAMETERS, null);
        } else {
            this._doParametersRename(aaiChannel, this._newChannelName, this._oldChannelName);
        }
    }

    /**
     * Does the work of renaming parameters for an aai channel.
     * 
     * @param {AaiChannelItem} aaiChannel
     * @param {string} from
     * @param {string} to
     * @private
     * @private
     */
    /*private*/ _doParametersRename(aaiChannel : AaiChannelItem, from : string, to : string) {
        let fromChannelParamNames : Array<string> = ModelUtils.detectPathParamNames(from);
        let toChannelParamNames : Array<string> = ModelUtils.detectPathParamNames(to);
        if(/* size */(<number>fromChannelParamNames.length) !== /* size */(<number>toChannelParamNames.length)) {
            LoggerCompat.warn("Renaming a channel with %o parameters to a new value that has %o parameters!", /* size */(<number>fromChannelParamNames.length), /* size */(<number>toChannelParamNames.length));
        }
        let parameterRenames : Array<string[]> = this._processPathParameterRenames(fromChannelParamNames, toChannelParamNames);
        for(let index154=0; index154 < parameterRenames.length; index154++) {
            let namePair = parameterRenames[index154];
            {
                if(ModelUtils.isNullOrUndefined(namePair[0])) {
                    this._createChannelParameter(aaiChannel, namePair[1]);
                } else if(ModelUtils.isNullOrUndefined(namePair[1])) {
                    this._removeChannelParameter(aaiChannel, namePair[0]);
                } else {
                    this._renameChannelParameter(aaiChannel, namePair[0], namePair[1]);
                }
            }
        }
        if(ModelUtils.isDefined(aaiChannel.parameters) && /* isEmpty */(Object.keys(aaiChannel.parameters).length == 0)) {
            NodeCompat.setProperty(aaiChannel, Constants.PROP_PARAMETERS, null);
        }
    }

    /**
     * Preprocesses the parameter renames mapping
     * 
     * @param {string[]} fromChannelParamNames the original channel parameter names
     * @param {string[]} toChannelParamNames   the new channel parameter names
     * @return {Array[]} a collection of [oldName, newName] pairs, null values mark fields as inexistent on either side
     * @private
     */
    /*private*/ _processPathParameterRenames(fromChannelParamNames : Array<string>, toChannelParamNames : Array<string>) : Array<string[]> {
        let ret : Array<string[]> = <any>([]);
        let knownParamNames : Array<string> = <any>([]);
        let addedParamNames : Array<string> = <any>([]);
        let removedParamNames : Array<string> = <any>([]);
        fromChannelParamNames.forEach(((knownParamNames,removedParamNames) => {
            return (name) => {
                if(!/* contains */(knownParamNames.indexOf(<any>(name)) >= 0)) {
                    /* add */(knownParamNames.push(name)>0);
                    if(!/* contains */(toChannelParamNames.indexOf(<any>(name)) >= 0)) {
                        /* add */(removedParamNames.push(name)>0);
                    }
                }
            }
        })(knownParamNames,removedParamNames));
        toChannelParamNames.forEach(((addedParamNames,knownParamNames) => {
            return (name) => {
                if(!/* contains */(knownParamNames.indexOf(<any>(name)) >= 0)) {
                    /* add */(knownParamNames.push(name)>0);
                    if(!/* contains */(fromChannelParamNames.indexOf(<any>(name)) >= 0)) {
                        /* add */(addedParamNames.push(name)>0);
                    }
                }
            }
        })(addedParamNames,knownParamNames));
        let minIndex : number = Math.min(/* size */(<number>removedParamNames.length), /* size */(<number>addedParamNames.length));
        let idx : number = 0;
        while((idx < minIndex)) {{
            /* add */(ret.push([/* get */removedParamNames[idx], /* get */addedParamNames[idx]])>0);
            idx++;
        }};
        while((idx < /* size */(<number>removedParamNames.length))) {{
            /* add */(ret.push([/* get */removedParamNames[idx], null])>0);
            idx++;
        }};
        while((idx < /* size */(<number>addedParamNames.length))) {{
            /* add */(ret.push([null, /* get */addedParamNames[idx]])>0);
            idx++;
        }};
        return ret;
    }

    /**
     * Create a channel parameter.
     * 
     * @param {AaiChannelItem} channel
     * @param {string} paramName
     * @private
     */
    /*private*/ _createChannelParameter(channel : AaiChannelItem, paramName : string) {
        let parameters : any = channel.parameters;
        if(ModelUtils.isNullOrUndefined(parameters)) {
            parameters = <any>({});
            NodeCompat.setProperty(channel, Constants.PROP_PARAMETERS, parameters);
        }
        let parameter : AaiParameter = this._nodeFactory.createParameter(channel, paramName);
        let restorable : any = /* remove */(map => { let deleted = this._paramBin[paramName];delete this._paramBin[paramName];return deleted;})(this._paramBin);
        if(ModelUtils.isDefined(restorable)) {
            Library.readNode(restorable, parameter);
        }
        /* put */(parameters[paramName] = parameter);
    }

    /**
     * Rename a channel parameter.
     * 
     * @param {AaiChannelItem} channel
     * @param {string} fromParamName
     * @param {string} toParamName
     * @private
     */
    /*private*/ _renameChannelParameter(channel : AaiChannelItem, fromParamName : string, toParamName : string) {
        if(ModelUtils.isDefined(channel.parameters)) {
            let param : AaiParameter = /* remove */(map => { let deleted = channel.parameters[fromParamName];delete channel.parameters[fromParamName];return deleted;})(channel.parameters);
            if(ModelUtils.isDefined(param)) {
                param.rename(toParamName);
                channel.addParameter(toParamName, param);
            }
        }
    }

    /**
     * Remove a channel parameter.
     * 
     * @param {AaiChannelItem} channel
     * @param {string} paramName
     * @private
     */
    /*private*/ _removeChannelParameter(channel : AaiChannelItem, paramName : string) {
        if(this.isNullOrUndefined(channel.parameters)) {
            return;
        }
        let removed : AaiParameter = /* remove */(map => { let deleted = channel.parameters[paramName];delete channel.parameters[paramName];return deleted;})(channel.parameters);
        if(ModelUtils.isDefined(removed)) {
            /* put */(this._paramBin[paramName] = Library.writeNode(removed));
        }
    }
}
RenameChannelItemCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameChannelItemCommand";
RenameChannelItemCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




